import ApplicationSerializer from 'lumen/serializers/application';

export default class SegmentSerializer extends ApplicationSerializer {
  attrs = {
    parent: 'parent_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('budget-forecast/segment');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
